export default {
  common: {
    search: "Search",
    confirm: "Confirm",
    cancel: "Cancel",
    phone: "phone",
    location: "location",
  },
  login: {
    title: "Login",
    username: "Username",
  },
};
